import React, { useEffect, useState } from "react";
import { Card, CardContent, Grid } from "@mui/material";
import {
  PURCHASE_ORDER_COLUMN,
  QC_REJECTED_COLUMNS,
} from "../../columns/columns";
import CounterCard from "../../components/CounterCard";
import {
  getPurchaseOrdersDetails,
  getRejectedQC,
} from "../../services/dataService";
import PurchaseOrderTable from "../../components/table/PurchaseOrderTable";
import { dateBeforeMonths, today } from "../../manager/dateManager";
import { createPOCards, getPOCardCount } from "../../manager/cardManager";
import store from "../../store/Store";
import {
  dispatcher,
  requestPOFromStore,
  requestRejectedQCForPOFromStore,
} from "../../store/helper";
import {
  PURCHASE_ORDER_LOADED,
  REJECTED_QC_FOR_PO_LOADED,
} from "../../store/ActionType";
import {
  isCompletedOrder,
  isOverDue,
  isPartialPO,
  isPO,
  localStorageItem,
} from "../../helpers/poStateIdentifier";
import { getUser } from "../../services/authService";
import { poDataCreator, poDataExcelCreator } from "../../helpers/dateExtractor";

function PurchaseOrders() {
  const user = getUser();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [PONumber, setPONumber] = useState("");
  const [fromDate, setFromDate] = useState(dateBeforeMonths(4));
  const [toDate, setToDate] = useState(today());
  const [overviewItems, setOverviewItems] = useState(createPOCards("loading"));
  const [activeCard, setActiveCard] = useState(localStorageItem());

  const getPurchaseOrder = async () => {
    var qcReject = [];
    var poList = [];
    setLoading(true);
    try {
      const response = await getPurchaseOrdersDetails({
        FromDate: fromDate,
        ToDate: toDate,
        PONumber: PONumber,
      });
      poList = response.data;
      dispatcher(PURCHASE_ORDER_LOADED, response.data);
    } catch (error) {
      setTableData([]);
    }
    try {
      const qcRejectResponse = await getRejectedQC({
        FromDate: fromDate,
        ToDate: toDate,
      });
      qcReject = qcRejectResponse.data;
      dispatcher(REJECTED_QC_FOR_PO_LOADED, qcRejectResponse.data);
    } catch (error) {
    }
    setLoading(false);
    setOverviewItems(createPOCards(getPOCardCount(poList, qcReject)));
  };
 

  const sortingHandler = (status, userEvent) => {
    if(userEvent !== "clicked"){
      status = localStorage.getItem("purchaseOrder")
    }
    localStorage.setItem("purchaseOrder", status)
    setActiveCard(status);
    const storeData = requestPOFromStore();
    const qcRejectData = requestRejectedQCForPOFromStore();
    if (status === "Purchase Orders") {
      var remainingPO = [];
      var overduePO = [];
      for (const item of storeData) {
        if (isPO(item) && !isCompletedOrder(item)) {
          if (isOverDue(item)) {
            overduePO.push(item);
          }
          remainingPO.push(item);
        }
      }
      if (userEvent === true) {
        setTableData(overduePO);
      } else {
        setTableData(remainingPO);
      }
    } else if (status === "Partial Orders") {
      var partialOrders = [];
      var partialOverDue = [];
      for (const item of storeData) {
        if (isPartialPO(item)) {
          if (isOverDue(item)) {
            partialOverDue.push(item);
          }
          partialOrders.push(item);
        }
      }

      if (userEvent === true) {
        setTableData(partialOverDue);
      } else {
        setTableData(partialOrders);
      }
    } else if (status === "Completed") {
      var dueThisWeek = [];
      for (const item of storeData) {
        if (isCompletedOrder(item)) {
          dueThisWeek.push(item);
        }
      }
      setTableData(dueThisWeek);
    } else if (status === "QC Failed") {
      setTableData(qcRejectData);
    }
    setOverviewItems(createPOCards(getPOCardCount(storeData, qcRejectData)));
  };

  const getOverDuePO = (e) => {
    var overDue = [];
    if (e.target.checked === true) {
      for (const item of tableData) {
        if (isOverDue(item) && item.LatestAction !== "Completed") {
          overDue.push(item);
        }
      }
      setTableData(overDue);
    } else {
      sortingHandler(activeCard, e.target.checked);
    }
  };

  useEffect(() => {
    if (requestPOFromStore().length === 0) {
      getPurchaseOrder();
    } else {
      sortingHandler(activeCard);
    }
    const unsubscribe = store.subscribe(() => {
      sortingHandler(activeCard);
    });
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getColumns = () => {
    if (activeCard === "QC Failed") {
      return QC_REJECTED_COLUMNS;
    } else if (activeCard === "Completed") {
      const col = [];
      PURCHASE_ORDER_COLUMN.forEach((item) => {
        if (item.accessor !== "PendingQTY") {
          col.push(item);
        }
      });
      return col;
    } else if (
      user?.globalID &&
      (user?.isSupplierFinance || user?.isSupplierOperation)
    )
      return [
        ...PURCHASE_ORDER_COLUMN,
        {
          Header: "PRICE CHANGE",
          accessor: "price_change_request",
          show: true,
        },
      ];
    else if (
      !user?.globalID &&
      (user?.isImpexOperation || user?.isImpexFinance)
    ) {
      return [
        ...PURCHASE_ORDER_COLUMN
      ];
    } else return PURCHASE_ORDER_COLUMN;
  };

  return (
    <>
      <Grid container spacing={2} marginTop={0}>
        <Grid container spacing={2}>
          {overviewItems.map((item, index) => (
            <Grid key={index} item xs={12} sm={6} md={3} lg={3}>
              <CounterCard
                description={item.name}
                title={item.value}
                icon={item.icon}
                color={item.dark}
                bgColor={item.light}
                onClickHandler={() => {
                  sortingHandler(item.name, "clicked");
                }}
                isActive={activeCard === item.name}
              />
            </Grid>
          ))}
          <Grid item xs={12} md={12}>
            <Card>
              <CardContent>
                <PurchaseOrderTable
                  data={
                    activeCard !== "QC Failed"
                      ? poDataCreator(tableData)
                      : tableData
                  }
                  columns={getColumns()}
                  fromDate={fromDate}
                  toDate={toDate}
                  handleFromDate={(e) => setFromDate(e.target.value)}
                  handleToDate={(e) => setToDate(e.target.value)}
                  callAPI={getPurchaseOrder}
                  PONumber={PONumber}
                  setPONumber={(e) => setPONumber(e.target.value)}
                  loading={loading}
                  getOverDuePO={getOverDuePO}
                  activeCard={activeCard}
                  totalOverdue={
                    tableData.filter((item) => isOverDue(item)).length
                  }
                  expandedTable={activeCard !== "QC Failed"}
                  excelData={
                    activeCard !== "QC Failed"
                      ? poDataExcelCreator(tableData)
                      : tableData
                  }
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default PurchaseOrders;
